import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IBillNoFreight } from "../models/bnfException";
import { throwApiError } from "./apiError";

/**
 * GET API call using Axios
 */

export const getBillNoFreightEditViewAPI = async (osdNumber: number | string): Promise<IBillNoFreight | undefined> => {
  try {
    const response = await axios.get(`${getUrl(ApiType.BNF_EDIT_VIEW)}/${osdNumber}`);
    return response?.data ?? {};
  } catch (error) {
    throwApiError(error, ErrorMessages.bnfEntryDetailsAPIError, { badRequestOrder: "errorsFirst" });
  }
};
